import L from 'leaflet';

import * as turf from '@turf/turf';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions(
    {
        iconRetinaUrl: markerIcon2x,
        iconUrl: markerIcon,
        shadowUrl: markerShadow
    }
);

const ZONE_COLORS = [
    {label: 'SNOW_I', color: '#F0B8B0'},
    {label: 'SNOW_II', color: '#FCDF83'},
    {label: 'SNOW_III', color: '#BAE278'},
    {label: 'SNOW_IV', color: '#84BB23'},
    {label: 'SNOW_V', color: '#6DB9E0'},
    {label: 'SNOW_VI', color: '#6B76F1'},
    {label: 'SNOW_VII', color: '#4E30D6'},
    {label: 'SNOW_VIII', color: '#4C2A8B'},
    {label: 'WIND_I', color: '#F0B8B0'},
    {label: 'WIND_II', color: '#FCDF83'},
    {label: 'WIND_III', color: '#BAE278'},
    {label: 'WIND_IV', color: '#6B76F1'},
    {label: 'WIND_V', color: '#4C2A8B'},
];

class Map {
    constructor(id) {
        this.map = L.map(id, {
            zoomSnap: 0.2
        }).setView([49.8203, 15.4874], 7.6);

        this.map.attributionControl.setPrefix(
            '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>');

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        this.map.invalidateSize();


        this.marker = null;

        this.zones = [];
    }

    addZones(zones) {
        zones.forEach((zone) => {
            const color = ZONE_COLORS.find((c) => c.label === zone.label).color;
            const zoneStyle = {
                color: '#000',
                weight: .8,
                fillOpacity: 0.6,
                fillColor: color,
            };
            const zoneLayer = L.geoJson(zone.geojson,{
                style: zoneStyle
            }).addTo(this.map);

            zoneLayer.on('click', (event) => {
                window.dispatchEvent(new CustomEvent('map-click', {detail: event.latlng}));
            });

            this.zones.push(zone.geojson);
        });
    }

    setMarker(lat, lng) {
        if (this.marker) {
            this.marker.setLatLng([lat, lng]);
        } else {
            this.marker = L.marker([lat, lng]).addTo(this.map);
        }
    }

    getZone(lat, lng) {
        const clickedPoint = turf.point([+lng, +lat]);

        for (const zoneGeoJson of this.zones) {
            const zoneLabel = zoneGeoJson.name;
            for (const feature of zoneGeoJson.features) {
                const searchWithin = turf.multiPolygon(feature.geometry.coordinates);
                if (turf.booleanPointInPolygon(clickedPoint, searchWithin)) {
                    return zoneLabel;
                }
            }
        }
        return null;
    }
}

window.WBApp.utils.Map = Map;
